module.exports = __webpack_public_path__ + "a944a75f8fedd79f1b94cb6c458f7b1f.jpg";